import React from "react";

export default ({ kick }) => (
  <div className="swiper-slide">
  	<img src={require("../images/fetus-kick.png")}/>
    <span className="kick-count M14_9a2037">{kick}</span>
  </div>
);



// WEBPACK FOOTER //
// src/shared/tools/fetal-movement-tracker/slideItem.js